import { useEffect, useState } from "react";
import { useUserStore } from "../store/userStore";
import { studioHost } from "@/common/utils/env";

export const useRedirectToStudio = (page: string, callback?: () => boolean) => {
  const [redirectingToStudio, setRedirectingToStudio] = useState<boolean>(false);
  const verifiedUser = useUserStore((state) => state.currentUser?.verified);

  useEffect(() => {
    if (verifiedUser) {
      const canRedirect = callback ? callback() : true;

      if (canRedirect) {
        setRedirectingToStudio(true);
        window.location.href = `https://${studioHost}/${page}`;
      }
    }
  }, [verifiedUser, callback]);

  useEffect(() => {
    if (!redirectingToStudio) {
      return;
    }

    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.href = `https://${studioHost}/${page}`;
      }
    };

    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [redirectingToStudio]);

  return { redirectingToStudio };
};
